const API_BASE = import.meta.env.VITE_SHARE_API || "https://mdview.co";

export interface ShareResult {
  id: string;
  url: string;
}

export interface ShareError {
  error: string;
}

export async function createShare(markdown: string): Promise<ShareResult> {
  const res = await fetch(`${API_BASE}/api/share`, {
    method: "POST",
    body: markdown,
    headers: { "Content-Type": "text/plain" },
  });

  const contentType = res.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    throw new Error("Share service unavailable. Please try again later.");
  }

  const data = (await res.json()) as ShareResult | ShareError;

  if (!res.ok) {
    throw new Error(
      (data as ShareError).error || `Share failed (${res.status})`,
    );
  }

  return data as ShareResult;
}
